export class AuthorizationService {
    private baseUrl: string;

    private sessionStartEndpoint = '/v1/user/session/start';
    private sessionEndEndpoint = '/v1/user/session/end';
    private authorizationEndpoint = '/v1/user/authorization';

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    async startSession(userId: string): Promise<string> {
        try {
            const response = await fetch(`${this.baseUrl}${this.sessionStartEndpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 'user_id': userId }),
            });

            if (!response.ok) {
                throw new Error('Failed to start session');
            }

            const data = await response.json();
            console.log('Session started:', data);
            return data.session_id;
        } catch (error) {
            console.error('Failed to start session:', error);
            throw new Error('Failed to start session');
        }
    }

    async sessionEnd(sessionId: string, useBeacon = false): Promise<string> {
        try {
            if (useBeacon) {
                navigator.sendBeacon(`${this.baseUrl}${this.sessionEndEndpoint}`, JSON.stringify({ 'session_id': sessionId }));
                return 'Session ended';
            }

            const response = await fetch(`${this.baseUrl}${this.sessionEndEndpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 'session_id': sessionId }),
            });

            if (!response.ok) {
                throw new Error('Failed to end session');
            }

            const data = await response.json();
            console.log('Session ended:', data);
            return data.message;
        } catch (error) {
            console.error('Failed to end session:', error);
            throw new Error('Failed to end session');
        }
    }

    async authorize(userId: string, sessionId: string): Promise<boolean> {
        const url = `${this.baseUrl}${this.authorizationEndpoint}`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 'user_id': userId, 'session_id': sessionId }),
            });

            if (!response.ok && response.status !== 401) {
                throw new Error('Failed to authorize user');
            }

            const data = await response.json();
            return data.authorized;
        } catch (error) {
            console.error('Authorization failed:', error);
            throw new Error('Authorization failed');
        }
    }
}
